module.exports = __webpack_public_path__ + "static/media/AskCommunity.716cfbca.svg";